import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
  name: 'money'
})
export class MoneyPipe implements PipeTransform {

  transform(value: any): any {
    const float = parseFloat(value);
    return Number(value).toFixed(2);
  }

}
